// Timeline

import app from "../a4_app";

export const timeline = {
  init: () => {
    $(document).on('click', '.timeline__load-more__button', function(e) {
      const $button = $(this);
      const $loadMore = $button.closest('.timeline__load-more');
      const $group = $button.closest('.timeline-module-group');
      const perPage = parseInt($group.attr('data-per-page')) || 12;
      const $parent = $button.closest('.timeline__load-more');
      const $nextAll = $parent.nextAll('.timelineable-module--hidden');
      const $next = $nextAll.slice(0, perPage);
      const showLoadMore = $nextAll.length > perPage;

      $next.removeClass('timelineable-module--hidden');

      if (showLoadMore) {
        $loadMore.insertAfter($next.last());
      } else {
        $loadMore.remove();
      }
    });
  }
}
